<template>
  <svg width="232" height="83" viewBox="0 0 232 83" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.628906 80.3982C128.81 82.9764 122.619 0.474591 231.136 2.0215" stroke="#CA3C2C" stroke-width="4" stroke-dasharray="12 12" />
  </svg>
</template>
